module.exports = __webpack_public_path__ + "img/kraemer.723921bf.jpeg";